import InputField from "components/fields/InputField";
import { IntegrationTypeConfiguration } from "../types";

interface StringConfigurationFieldProps {
  config: IntegrationTypeConfiguration;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
}

const StringConfigurationField = ({
  config,
  value,
  onChange,
  disabled = false,
  error,
}: StringConfigurationFieldProps) => {
  return (
    <div>
      <InputField
        id={config.name}
        label={config.name}
        value={value || ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        type={config.is_secure ? "password" : "text"}
        placeholder={config.name}
        disabled={disabled}
        state={error ? "error" : undefined}
      />
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default StringConfigurationField;

